export default __webpack_public_path__ + "static/media/r2.92af49c0.png";